import socket from 'providers/socket'

const socketPlugin = store => {
  socket.on('modelChanged', ({ namespace, id, operation }) => {
    console.debug('modelChanged', namespace, id, operation)

    if (id) {
      switch (operation) {
        case 'create':
        case 'edit':
          store.commit(`${namespace}/addToChanges`, id)

          break
        case 'delete':
          store.commit(`${namespace}/removeOne`, { id })

          return // Everything is done here!
      }
    }

    store.commit(`${namespace}/setForceUpdate`, true)
  })

  store.subscribe(({ type, payload }, state) => {
    // console.log('Mutation: ', type, payload, state)
  })
}

export default socketPlugin



// WEBPACK FOOTER //
// ./src/store/plugins/socketPlugin.js